export interface BridgeChartTheme {
  text: string;
  muted: string;
  grid: string;
  axis: string;
  up: string;
  down: string;
  volume: string;
  sma: string;
  ema: string;
  signal: string;
  idea: string;
  crosshair: string;
}

export const defaultTheme: BridgeChartTheme = {
  text: "#344054",
  muted: "#667085",
  grid: "rgba(102, 112, 133, 0.16)",
  axis: "#98a2b3",
  up: "#079455",
  down: "#d92d20",
  volume: "rgba(71, 84, 103, 0.28)",
  sma: "#2563eb",
  ema: "#dc6803",
  signal: "#7f56d9",
  idea: "#0891b2",
  crosshair: "rgba(52, 64, 84, 0.48)"
};

export const terminalTheme: BridgeChartTheme = {
  text: "#cbd5dc", muted: "#91a3b0", grid: "#293c48", axis: "#637987",
  up: "#94bf73", down: "#e36147", volume: "#506777", sma: "#71aaff",
  ema: "#efad62", signal: "#ad92ed", idea: "#62c9d5", crosshair: "#8ea6b7"
};
